// 该文件用于创建Vuex中最为核心的store

// 引入Vuex
import Vuex from "vuex"
//引入 Vue
import Vue from "vue"
//使用Vuex,使用Vuex之前要引入Vue
Vue.use(Vuex)

// 准备actions-用于响应组件中的动作
const actions = {}

// 准备mutations-用于操作数据（state）
const mutations = {
    ShowPage(state,value){
        state.currentPage = value
    },
    OpenPage(state,value){
        state.openCurrentPagePath = value
    }
    
}

// 准备state-用于存储数据
const state = {
    currentPage:"",
    openCurrentPagePath:""
}

// 创建并暴露store
export default new Vuex.Store({
    actions,
    mutations,
    state
})


// WEBPACK FOOTER //
// ./src/store/index.js